import { useSelector } from "react-redux";
import Link from "../../components/Button/LinkButton";
import Image from "../../components/Image";
import { IoMdSettings } from "react-icons/io";
const AdminNav = () => {
  const { userInfo } = useSelector((state) => state.auth);
  return (
    <div className="w-full">
      <div className="w-full border border-gray px-4 py-2 flex items-center  justify-between ">
        <div className="flex justify-center items-center gap-3">
          <Link
            to="/"
            as={Image}
            src="/assets/xavierlogo.png"
            alt="Logo"
            className="w-[60px] h-[60px] cursor-pointer"
          ></Link>
          <div className="flex flex-col justify-center ">
            <div className="text-lg font-bold text-primary">
              Doctor International Education
            </div>
            <div className="text-base font-bold tg-lgray">Admin Portal</div>
          </div>
        </div>
        <div className="flex justify-center items-center gap-2">
          <div className="tg-lgray">
            <IoMdSettings className="text-gray-400 h-[20px] w-[20px] cursor-pointer" />
          </div>
          <button className="h-[60px] cursor-pointer w-[60px] rounded-full overflow-hidden   focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2 focus:white">
            <Image
              className="h-full w-full object-cover"
              src={"/assets/indianguy.jpg"}
            />
          </button>
          <div className="flex flex-col">
            <p className="font-bold text-primary text-sm">{userInfo.name}</p>
            <p className="tg-lgray text-sm">{userInfo._id.substr(0, 9)}</p>
          </div>
        </div>
      </div>
    </div>
  );
};
export default AdminNav;
